import angular from 'angular';
import angularElastic from 'angular-elastic/elastic';
import uiRouter from 'angular-ui-router';
import celect from 'celect';
import pleaflet from 'pleaflet/index';
import ngDialog from 'ng-dialog/js/ngDialog';
import ngFileUpload from 'ng-file-upload'
import ngInfiniteScroll from 'ng-infinite-scroll/build/ng-infinite-scroll';
import angularFileSaver from 'angular-file-saver/dist/angular-file-saver.bundle';

import dashboardModule from './screens/dashboard';
import membersModule from './screens/members';
import mysolvrEntriesModule from './screens/mysolvr-entries';
import settingsModule from './screens/settings';
import tasksModule from './screens/tasks';
import searchPageModule from './screens/search-page';

import engineerRun from './engineer.run';
import 'band.scss';
import 'vertical-menu.scss';
import 'p-input-group.scss';
import charactersFilter from 'characters.filter';
import humanizedDateFilter from 'humanized-date.filter';
import inMinutesFilter from 'in-minutes.filter';
import actionsBtnComponent from 'actions-btn';
import expertisesTableComponent from 'expertises-table';
import proficiencyActionsMenuComponent from 'proficiency-actions-menu';
import pageHeaderComponent from 'page-header';
import popoverMenuComponent from 'popover-menu';
import profileMenuComponent from 'profile-menu';
import searchFormComponent from 'search-form';
import taskCardComponent from 'task-card';
import engineerComponent from './engineer.component';

let engineerModule = angular.module('engineer', [
  angularElastic,
  angularFileSaver,
  ngDialog,
  ngInfiniteScroll,
  ngFileUpload,
  uiRouter,
  celect.name,
  dashboardModule.name,
  pleaflet.name,
  membersModule.name,
  mysolvrEntriesModule.name,
  settingsModule.name,
  tasksModule.name,
  searchPageModule.name,
])
  .config(($stateProvider) => {
    "ngInject";

    $stateProvider
      .state('engineer', {
        url: '',
        abstract: true,
        template: '<engineer current-user="$resolve.currentUser" class="engineer"></engineer>',
        resolve: {
          currentUser: (Auth, $state) => {
            return Auth.getCurrentUser().catch(reason => $state.go('login', { rejectReason: reason }));
          },
        }
      });
  })
  .run(engineerRun)
  .filter('characters', charactersFilter)
  .filter('humanizedDate', humanizedDateFilter)
  .filter('inMinutes', inMinutesFilter)
  .component('actionsBtn', actionsBtnComponent)
  .component('expertisesTable', expertisesTableComponent)
  .component('proficiencyActionsMenu', proficiencyActionsMenuComponent)
  .component('pageHeader', pageHeaderComponent)
  .component('popoverMenu', popoverMenuComponent)
  .component('profileMenu', profileMenuComponent)
  .component('searchForm', searchFormComponent)
  .component('taskCard', taskCardComponent)
  .component('engineer', engineerComponent);

export default engineerModule;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/index.js